import { render } from "./DynamicIntelligence.vue?vue&type=template&id=beb03e2a&scoped=true"
import script from "./DynamicIntelligence.vue?vue&type=script&lang=js"
export * from "./DynamicIntelligence.vue?vue&type=script&lang=js"

import "./DynamicIntelligence.vue?vue&type=style&index=0&id=beb03e2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb03e2a"]])

export default __exports__